import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../Layout"
import { DistratoForm } from "../modais"
class DistratosEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/distratos")
  }
  render() {
    return (
      <Layout tabActive="Distratos">
        <DistratoForm isEditing={true} callBack={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(DistratosEditForm)



// WEBPACK FOOTER //
// ./src/views/distratos/DistratosEditForm.js